import { hasRecoveryData, saveRecoveryData } from "../data";
import { AdBlockerType, SoftwallRecoveredType } from "../types";
import {
  appendKVPToAdRequest,
  sendEvent,
  isMobile,
  isSessionRecovered,
} from "../utils";
import { log } from "../utils/logs";

export const onRecover = (
  recovered: SoftwallRecoveredType,
  detectedExtension: AdBlockerType,
  attributionWindow: number,
) => {
  const { isActive, attributionExpiry } = isSessionRecovered(
    recovered,
    attributionWindow,
  );

  if (isActive) {
    appendKVPToAdRequest();
    log(
      "rlink.appendKVP",
      {
        version: __SCRIPT_VERSION__,
        aaResults: window.__bt_intrnl.aaDetectionResults,
        isMobile: isMobile(),
        attributionExpiry: attributionExpiry,
        consentData: window.__bt_intrnl.consentData,
      },
      { severity: 1 },
    );
  }

  if (!hasRecoveryData()) {
    saveRecoveryData(recovered, attributionExpiry);

    sendEvent({
      event: "recovered",
      recoveryType: recovered,
      detectedExtension,
    });
  }
};
